import { TableParams } from '../types';

export type GetPhasesParams = TableParams & { [key: string]: string | boolean | any };

export type PhaseInfo = {
  id?: string;
  code: string;
  description: string;
  status: 'active' | 'inactive' | '';
};
export type PhaseModalType = 'EDIT' | 'ADD' | false | null;

export const PhaseModalTypes = {
  ADD: 'ADD',
  EDIT: 'EDIT',
};

export type DeletePhasePayload = {
  id: number;
};
